export default "__VITE_ASSET__221b51d2__"